import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const AgentVerified = () => (
  <svg viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.814 10.5V9.5C11.814 8.96957 11.6033 8.46086 11.2282 8.08579C10.8531 7.71071 10.3444 7.5 9.81397 7.5H6.81397C6.28353 7.5 5.77482 7.71071 5.39975 8.08579C5.02468 8.46086 4.81396 8.96957 4.81396 9.5V10.5"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ fill: 'none' }}
    />
    <path
      d="M8.31396 5.5C9.41853 5.5 10.314 4.60457 10.314 3.5C10.314 2.39543 9.41853 1.5 8.31396 1.5C7.2094 1.5 6.31396 2.39543 6.31396 3.5C6.31396 4.60457 7.2094 5.5 8.31396 5.5Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ fill: 'none' }}
    />
    <line
      x1="12.3092"
      y1="1.63388"
      x2="3.30918"
      y2="10.6339"
      stroke="var(--psima-source-badge-bg)"
      strokeWidth="2.5"
    />
    <path
      d="M5.07009 5.32277L4.34204 5.51636C3.71498 5.6889 3.22681 6.17708 3.05005 6.80834L2.85647 7.5364C2.78913 7.77628 2.45245 7.77628 2.39353 7.5364L2.19995 6.80834C2.0274 6.18129 1.53923 5.69311 0.907964 5.51636L0.17991 5.32277C-0.0599698 5.25544 -0.0599698 4.91876 0.17991 4.85985L0.907964 4.66626C1.53502 4.49371 2.02319 4.00554 2.19995 3.37427L2.39353 2.64622C2.46087 2.40634 2.79755 2.40634 2.85647 2.64622L3.05005 3.37427C3.2226 4.00133 3.71077 4.48951 4.34204 4.66626L5.07009 4.85985C5.30997 4.92718 5.30997 5.26385 5.07009 5.32277Z"
      fill="currentColor"
    />
    <path
      d="M5.17295 1.43994L4.86062 1.52213C4.59349 1.5961 4.3839 1.80569 4.30582 2.07692L4.22363 2.38925C4.19486 2.49199 4.05103 2.49199 4.02637 2.38925L3.94418 2.07692C3.8702 1.8098 3.66062 1.60021 3.38938 1.52213L3.07705 1.43994C2.97432 1.41117 2.97432 1.26734 3.07705 1.24268L3.38938 1.16049C3.65651 1.08651 3.8661 0.876925 3.94418 0.605692L4.02637 0.293363C4.05514 0.190624 4.19897 0.190624 4.22363 0.293363L4.30582 0.605692C4.37979 0.872816 4.58938 1.0824 4.86062 1.16049L5.17295 1.24268C5.27569 1.27145 5.27569 1.41528 5.17295 1.43994Z"
      fill="currentColor"
    />
    <line
      x1="12.1753"
      y1="1.45711"
      x2="3.1324"
      y2="10.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ fill: 'none' }}
    />
  </svg>
)

export default withDefaultStyles(AgentVerified)
